// Configuración centralizada para react-pdf
import { pdf } from '@react-pdf/renderer';

// Registrar fuentes si es necesario
// Font.register({ family: 'Helvetica', src: ... });

// Configuración para evitar el error de BindingError
let sharedPdfInstance;
let generationQueue = Promise.resolve();

const getSharedPdfInstance = () => {
  if (!sharedPdfInstance) {
    sharedPdfInstance = pdf();
  }
  return sharedPdfInstance;
};

const enqueuePdfGeneration = (task) => {
  const run = generationQueue.then(task, task);
  generationQueue = run.then(
    () => undefined,
    () => undefined
  );
  return run;
};

const pdfConfig = {
  // Función para generar un blob a partir de un documento PDF
  generatePdfBlob: async (document) => {
    return enqueuePdfGeneration(async () => {
      try {
        const instance = getSharedPdfInstance();
        instance.updateContainer(document);
        const blob = await instance.toBlob();
        return blob;
      } catch (error) {
        console.error('Error al generar el PDF:', error);
        throw error;
      }
    });
  },
  
  // Función para generar una URL a partir de un documento PDF
  generatePdfUrl: async (document) => {
    try {
      const blob = await pdfConfig.generatePdfBlob(document);
      // Crear una URL para el blob
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error('Error al generar la URL del PDF:', error);
      throw error;
    }
  },
  
  // Función para limpiar la URL del blob cuando ya no se necesite
  cleanupPdfUrl: (url) => {
    if (url) {
      URL.revokeObjectURL(url);
    }
  }
};

export default pdfConfig;
